export default "__VITE_ASSET__D6xNm_Bs__"